// extracted by mini-css-extract-plugin
module.exports = {"saleTimeMessage":"SaleTimeMessage_saleTimeMessage__e71aB","noSaleTime":"SaleTimeMessage_noSaleTime__h5la9"};